export type GovbrNivel = {
  id: string;
  dataAtualizacao?: string;
};

const NIVEL_MINIMO_ASSINATURA = 2;

export const GOVBR_AUMENTAR_NIVEL_URL =
  'https://www.gov.br/governodigital/pt-br/conta-gov-br/conta-gov-br';

function normalizarNiveis(
  niveis: GovbrNivel | GovbrNivel[] | null | undefined,
): GovbrNivel[] {
  if (!niveis) {
    return [];
  }
  return Array.isArray(niveis) ? niveis : [niveis];
}

/** Mesma regra do controlador em gov_br_signature_authorize. */
export function podeAssinarComGovbr(
  niveis: GovbrNivel | GovbrNivel[] | null | undefined,
): boolean {
  const list = normalizarNiveis(niveis);
  if (!list.length) {
    return false;
  }
  if (list.length === 1 && parseInt(list[0].id, 10) < NIVEL_MINIMO_ASSINATURA) {
    return false;
  }
  return true;
}

export function getLatestGovbrNivelLabel(
  niveis: GovbrNivel | GovbrNivel[] | null | undefined,
): string {
  const list = normalizarNiveis(niveis);
  if (!list.length) {
    return 'não informado';
  }

  const latest = list.reduce((current, item) => {
    if (!item.dataAtualizacao || !current.dataAtualizacao) {
      return item;
    }
    return new Date(item.dataAtualizacao) > new Date(current.dataAtualizacao)
      ? item
      : current;
  }, list[0]);

  switch (latest.id) {
    case '1':
      return 'Bronze';
    case '2':
      return 'Prata';
    case '3':
      return 'Ouro';
    default:
      return 'não informado';
  }
}

export function getTituloNivelInsuficienteGovbr(
  niveis: GovbrNivel | GovbrNivel[] | null | undefined,
): string {
  return `Sua conta Gov.br está no nível ${getLatestGovbrNivelLabel(niveis)}`;
}
